// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-ref-box {
  width: 250px;
  max-height: 250px;
  padding: 20px;
  overflow: scroll;
  overflow-x: hidden;
  line-height: 1.25;
}
.popup-ref-box {
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}
.popup-ref-button {
  width: 100%;
  height: 20px;
  margin-top: 10px;
  font-size: 14px;
  text-align: left;
  border: none;
  cursor: pointer;
}
.popup-ref-box * {
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
}
`, "",{"version":3,"sources":["webpack://./src/components/popups/popupRefer/popupRefer.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB","sourcesContent":[".popup-ref-box {\n  width: 250px;\n  max-height: 250px;\n  padding: 20px;\n  overflow: scroll;\n  overflow-x: hidden;\n  line-height: 1.25;\n}\n.popup-ref-box {\n  user-select: text;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n}\n.popup-ref-button {\n  width: 100%;\n  height: 20px;\n  margin-top: 10px;\n  font-size: 14px;\n  text-align: left;\n  border: none;\n  cursor: pointer;\n}\n.popup-ref-box * {\n  user-select: text;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
